import { alpha, Theme } from "@mui/material";

export const authFieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 1,
    bgcolor: "background.paper",
    transition: "box-shadow 0.2s ease, border-color 0.2s ease",
    "& fieldset": {
      borderColor: "divider",
    },
    "&:hover fieldset": {
      borderColor: "primary.light",
    },
    "&.Mui-focused fieldset": {
      borderWidth: 1.5,
    },
  },
  "& .MuiInputLabel-root": {
    fontWeight: 500,
  },
};

export const authSubmitButtonSx = (theme: Theme) => ({
  mt: 3,
  py: 1.5,
  borderRadius: 1,
  fontSize: 16,
  boxShadow: `0 8px 24px ${alpha(theme.palette.primary.main, 0.28)}`,
  "&:hover": {
    boxShadow: `0 10px 28px ${alpha(theme.palette.primary.main, 0.34)}`,
  },
});

export const authPageSx = {
  minHeight: "100vh",
  bgcolor: "background.default",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  px: { xs: 3, sm: 4 },
  py: { xs: 6, sm: 4 },
};

export const authFormWidthSx = {
  width: "100%",
  maxWidth: 420,
};
